/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function (window) {
  var countries = [{
    value: "AF",
    label_en: "Afghanistan",
    label_it: "Afghanistan"
  },
                   {
                     value: "AX",
                     label_en: "Åland Islands",
                     label_it: "Isole Aland"
                   },
                   {
                     value: "AL",
                     label_en: "Albania",
                     label_it: "Albania"
                   },
                   {
                     value: "DZ",
                     label_en: "Algeria",
                     label_it: "Algeria"
                   },
                   {
                     value: "AS",
                     label_en: "American Samoa",
                     label_it: "Samoa americane"
                   },
                   {
                     value: "AD",
                     label_en: "Andorra",
                     label_it: "Andorra"
                   },
                   {
                     value: "AO",
                     label_en: "Angola",
                     label_it: ""
                   },
                   {
                     value: "AI",
                     label_en: "Anguilla",
                     label_it: "Anguilla"
                   },
                   {
                     value: "AQ",
                     label_en: "Antarctica",
                     label_it: "Antartide"
                   },
                   {
                     value: "AG",
                     label_en: "Antigua and Barbuda",
                     label_it: "Antigua e Barbuda"
                   },
                   {
                     value: "AR",
                     label_en: "Argentina",
                     label_it: "Argentina"
                   },
                   {
                     value: "AM",
                     label_en: "Armenia",
                     label_it: "Armenia"
                   },
                   {
                     value: "AW",
                     label_en: "Aruba",
                     label_it: "Aruba"
                   },
                   {
                     value: "AU",
                     label_en: "Australia",
                     label_it: "Australia"
                   },
                   {
                     value: "AT",
                     label_en: "Austria",
                     label_it: "Austria"
                   },
                   {
                     value: "AZ",
                     label_en: "Azerbaijan",
                     label_it: "Azerbaijan"
                   },
                   {
                     value: "BS",
                     label_en: "Bahamas",
                     label_it: "Bahamas"
                   },
                   {
                     value: "BH",
                     label_en: "Bahrain",
                     label_it: "Bahrain"
                   },
                   {
                     value: "BD",
                     label_en: "Bangladesh",
                     label_it: "Bangladesh"
                   },
                   {
                     value: "BB",
                     label_en: "Barbados",
                     label_it: "Barbados"
                   },
                   {
                     value: "BY",
                     label_en: "Belarus",
                     label_it: "Bielorussia"
                   },
                   {
                     value: "BE",
                     label_en: "Belgium",
                     label_it: "Belgio"
                   },
                   {
                     value: "BZ",
                     label_en: "Belize",
                     label_it: "Belize"
                   },
                   {
                     value: "BJ",
                     label_en: "Benin",
                     label_it: "Benin"
                   },
                   {
                     value: "BM",
                     label_en: "Bermuda",
                     label_it: "Bermuda"
                   },
                   {
                     value: "BT",
                     label_en: "Bhutan",
                     label_it: "Bhutan"
                   },
                   {
                     value: "BO",
                     label_en: "Bolivia",
                     label_it: "Bolivia"
                   },
                   {
                     value: "BQ",
                     label_en: "Bonaire, Sint Eustatius and Saba",
                     label_it: "Bonaire, Sint Eustatius e Saba"
                   },
                   {
                     value: "BA",
                     label_en: "Bosnia and Herzegovina",
                     label_it: "Bosnia Erzegovina"
                   },
                   {
                     value: "BW",
                     label_en: "Botswana",
                     label_it: "Botswana"
                   },
                   {
                     value: "BV",
                     label_en: "Bouvet Island",
                     label_it: "Isola Bouvet"
                   },
                   {
                     value: "BR",
                     label_en: "Brazil",
                     label_it: "Brasile"
                   },
                   {
                     value: "IO",
                     label_en: "British Indian Ocean Territory",
                     label_it: "Territorio britannico dell'Oceano Indiano"
                   },
                   {
                     value: "BN",
                     label_en: "Brunei Darussalam",
                     label_it: "Brunei Darussalam"
                   },
                   {
                     value: "BG",
                     label_en: "Bulgaria",
                     label_it: "Bulgaria"
                   },
                   {
                     value: "BF",
                     label_en: "Burkina Faso",
                     label_it: "Burkina Faso"
                   },
                   {
                     value: "BI",
                     label_en: "Burundi",
                     label_it: "Burundi"
                   },
                   {
                     value: "KH",
                     label_en: "Cambodia",
                     label_it: "Cambogia"
                   },
                   {
                     value: "CM",
                     label_en: "Cameroon",
                     label_it: "Camerun"
                   },
                   {
                     value: "CA",
                     label_en: "Canada",
                     label_it: "Canada"
                   },
                   {
                     value: "CV",
                     label_en: "Cape Verde",
                     label_it: "Capo Verde"
                   },
                   {
                     value: "KY",
                     label_en: "Cayman Islands",
                     label_it: "Isole Cayman"
                   },
                   {
                     value: "CF",
                     label_en: "Central African Republic",
                     label_it: "Repubblica Centrafricana"
                   },
                   {
                     value: "TD",
                     label_en: "Chad",
                     label_it: "Chad"
                   },
                   {
                     value: "CL",
                     label_en: "Chile",
                     label_it: "Cile"
                   },
                   {
                     value: "CN",
                     label_en: "China",
                     label_it: "Cina"
                   },
                   {
                     value: "CX",
                     label_en: "Christmas Island",
                     label_it: "Isola di Natale"
                   },
                   {
                     value: "CC",
                     label_en: "Cocos (Keeling) Islands",
                     label_it: "Isole Cocos (Keeling)"
                   },
                   {
                     value: "CO",
                     label_en: "Colombia",
                     label_it: "Colombia"
                   },
                   {
                     value: "KM",
                     label_en: "Comoros",
                     label_it: "Comoros"
                   },
                   {
                     value: "CG",
                     label_en: "Congo",
                     label_it: "Congo"
                   },
                   {
                     value: "CD",
                     label_en: "Democratic Republic of Congo",
                     label_it: "Repubblica Democratica del Congo"
                   },
                   {
                     value: "CK",
                     label_en: "Cook Islands",
                     label_it: "Isole Cook"
                   },
                   {
                     value: "CR",
                     label_en: "Costa Rica",
                     label_it: "Costa Rica"
                   },
                   {
                     value: "CI",
                     label_en: "Côte d'Ivoire",
                     label_it: "Costa d'Avorio"
                   },
                   {
                     value: "HR",
                     label_en: "Croatia",
                     label_it: "Croazia"
                   },
                   {
                     value: "CU",
                     label_en: "Cuba",
                     label_it: "Cuba"
                   },
                   {
                     value: "CW",
                     label_en: "Curaçao",
                     label_it: "Curaçao"
                   },
                   {
                     value: "CY",
                     label_en: "Cyprus",
                     label_it: "Cipro"
                   },
                   {
                     value: "CZ",
                     label_en: "Czech Republic",
                     label_it: "Repubblica Ceca"
                   },
                   {
                     value: "DK",
                     label_en: "Denmark",
                     label_it: "Danimarca"
                   },
                   {
                     value: "DJ",
                     label_en: "Djibouti",
                     label_it: "Djibouti"
                   },
                   {
                     value: "DM",
                     label_en: "Dominica",
                     label_it: "Dominica"
                   },
                   {
                     value: "DO",
                     label_en: "Dominican Republic",
                     label_it: "Repubblica Domenicana"
                   },
                   {
                     value: "EC",
                     label_en: "Ecuador",
                     label_it: "Ecuador"
                   },
                   {
                     value: "EG",
                     label_en: "Egypt",
                     label_it: "Egitto"
                   },
                   {
                     value: "SV",
                     label_en: "El Salvador",
                     label_it: "El Salvador"
                   },
                   {
                     value: "GQ",
                     label_en: "Equatorial Guinea",
                     label_it: "Guinea Equatoriale"
                   },
                   {
                     value: "ER",
                     label_en: "Eritrea",
                     label_it: "Eritrea"
                   },
                   {
                     value: "EE",
                     label_en: "Estonia",
                     label_it: "Estonia"
                   },
                   {
                     value: "ET",
                     label_en: "Ethiopia",
                     label_it: "Etiopia"
                   },
                   {
                     value: "FK",
                     label_en: "Falkland Islands (Malvinas)",
                     label_it: "Isole Falkland (Malvinas)"
                   },
                   {
                     value: "FO",
                     label_en: "Faroe Islands",
                     label_it: "Isole Faroe"
                   },
                   {
                     value: "FJ",
                     label_en: "Fiji",
                     label_it: "Fiji"
                   },
                   {
                     value: "FI",
                     label_en: "Finland",
                     label_it: "Finlandia"
                   },
                   {
                     value: "FR",
                     label_en: "France",
                     label_it: "Francia"
                   },
                   {
                     value: "GF",
                     label_en: "French Guiana",
                     label_it: "Guiana francese"
                   },
                   {
                     value: "PF",
                     label_en: "French Polynesia",
                     label_it: "Polinesia francese"
                   },
                   {
                     value: "TF",
                     label_en: "French Southern Territories",
                     label_it: "Territori della Francia del sud"
                   },
                   {
                     value: "GA",
                     label_en: "Gabon",
                     label_it: "Gabon"
                   },
                   {
                     value: "GM",
                     label_en: "Gambia",
                     label_it: "Gambia"
                   },
                   {
                     value: "GE",
                     label_en: "Georgia",
                     label_it: "Georgia"
                   },
                   {
                     value: "DE",
                     label_en: "Germany",
                     label_it: "Germania"
                   },
                   {
                     value: "GH",
                     label_en: "Ghana",
                     label_it: "Ghana"
                   },
                   {
                     value: "GI",
                     label_en: "Gibraltar",
                     label_it: "Gibilterra"
                   },
                   {
                     value: "GR",
                     label_en: "Greece",
                     label_it: "Grecia"
                   },
                   {
                     value: "GL",
                     label_en: "Greenland",
                     label_it: "Groenlandia"
                   },
                   {
                     value: "GD",
                     label_en: "Grenada",
                     label_it: "Grenada"
                   },
                   {
                     value: "GP",
                     label_en: "Guadeloupe",
                     label_it: "Guadeloupe"
                   },
                   {
                     value: "GU",
                     label_en: "Guam",
                     label_it: "Guam"
                   },
                   {
                     value: "GT",
                     label_en: "Guatemala",
                     label_it: "Guatemala"
                   },
                   {
                     value: "GG",
                     label_en: "Guernsey",
                     label_it: "Guernsey"
                   },
                   {
                     value: "GN",
                     label_en: "Guinea",
                     label_it: "Guinea"
                   },
                   {
                     value: "GW",
                     label_en: "Guinea-Bissau",
                     label_it: "Guinea-Bissau"
                   },
                   {
                     value: "GY",
                     label_en: "Guyana",
                     label_it: "Guyana"
                   },
                   {
                     value: "HT",
                     label_en: "Haiti",
                     label_it: "Haiti"
                   },
                   {
                     value: "HM",
                     label_en: "Heard Island and McDonald Islands",
                     label_it: "Isole Heard e isole McDonald"
                   },
                   {
                     value: "VA",
                     label_en: "Holy See (Vatican City State)",
                     label_it: "Città del Vaticano"
                   },
                   {
                     value: "HN",
                     label_en: "Honduras",
                     label_it: "Honduras"
                   },
                   {
                     value: "HK",
                     label_en: "Hong Kong",
                     label_it: "Hong Kong"
                   },
                   {
                     value: "HU",
                     label_en: "Hungary",
                     label_it: "Ungheria"
                   },
                   {
                     value: "IS",
                     label_en: "Iceland",
                     label_it: "Islanda"
                   },
                   {
                     value: "IN",
                     label_en: "India",
                     label_it: "India"
                   },
                   {
                     value: "ID",
                     label_en: "Indonesia",
                     label_it: "Indonesia"
                   },
                   {
                     value: "IR",
                     label_en: "Iran",
                     label_it: "Iran"
                   },
                   {
                     value: "IQ",
                     label_en: "Iraq",
                     label_it: "Iraq"
                   },
                   {
                     value: "IE",
                     label_en: "Ireland",
                     label_it: "IRlanda"
                   },
                   {
                     value: "IM",
                     label_en: "Isle of Man",
                     label_it: "Isola di Man"
                   },
                   {
                     value: "IL",
                     label_en: "Israel",
                     label_it: "Israele"
                   },
                   {
                     value: "IT",
                     label_en: "Italy",
                     label_it: "Italia"
                   },
                   {
                     value: "JM",
                     label_en: "Jamaica",
                     label_it: "Giamaica"
                   },
                   {
                     value: "JP",
                     label_en: "Japan",
                     label_it: "Giappone"
                   },
                   {
                     value: "JE",
                     label_en: "Jersey",
                     label_it: "Jersey"
                   },
                   {
                     value: "JO",
                     label_en: "Jordan",
                     label_it: "Giordania"
                   },
                   {
                     value: "KZ",
                     label_en: "Kazakhstan",
                     label_it: "Kazakhstan"
                   },
                   {
                     value: "KE",
                     label_en: "Kenya",
                     label_it: "Kenia"
                   },
                   {
                     value: "KI",
                     label_en: "Kiribati",
                     label_it: "Kiribati"
                   },
                   {
                     value: "KP",
                     label_en: "North Korea",
                     label_it: "Corea del Nord"
                   },
                   {
                     value: "KR",
                     label_en: "South Korea",
                     label_it: "Corea del Sud"
                   },
                   {
                     value: "KW",
                     label_en: "Kuwait",
                     label_it: "Kuwait"
                   },
                   {
                     value: "KG",
                     label_en: "Kyrgyzstan",
                     label_it: "Kyrgyzstan"
                   },
                   {
                     value: "LA",
                     label_en: "Lao People's Democratic Republic",
                     label_it: "Repubblica democratica popolare del Laos"
                   },
                   {
                     value: "LV",
                     label_en: "Latvia",
                     label_it: "Lettonia"
                   },
                   {
                     value: "LB",
                     label_en: "Lebanon",
                     label_it: "Libano"
                   },
                   {
                     value: "LS",
                     label_en: "Lesotho",
                     label_it: "Lesoto"
                   },
                   {
                     value: "LR",
                     label_en: "Liberia",
                     label_it: "Liberia"
                   },
                   {
                     value: "LY",
                     label_en: "Libya",
                     label_it: "Libia"
                   },
                   {
                     value: "LI",
                     label_en: "Liechtenstein",
                     label_it: "Liechtenstein"
                   },
                   {
                     value: "LT",
                     label_en: "Lithuania",
                     label_it: "Lituania"
                   },
                   {
                     value: "LU",
                     label_en: "Luxembourg",
                     label_it: "Lussemburgo"
                   },
                   {
                     value: "MO",
                     label_en: "Macao",
                     label_it: "Macao"
                   },
                   {
                     value: "MK",
                     label_en: "Macedonia",
                     label_it: "Macedonia"
                   },
                   {
                     value: "MG",
                     label_en: "Madagascar",
                     label_it: "Madagascar"
                   },
                   {
                     value: "MW",
                     label_en: "Malawi",
                     label_it: "Malawi"
                   },
                   {
                     value: "MY",
                     label_en: "Malaysia",
                     label_it: "Malaysia"
                   },
                   {
                     value: "MV",
                     label_en: "Maldives",
                     label_it: "Maldive"
                   },
                   {
                     value: "ML",
                     label_en: "Mali",
                     label_it: "Mali"
                   },
                   {
                     value: "MT",
                     label_en: "Malta",
                     label_it: "Malta"
                   },
                   {
                     value: "MH",
                     label_en: "Marshall Islands",
                     label_it: "Isole Marshall"
                   },
                   {
                     value: "MQ",
                     label_en: "Martinique",
                     label_it: "Martinique"
                   },
                   {
                     value: "MR",
                     label_en: "Mauritania",
                     label_it: "Mauritania"
                   },
                   {
                     value: "MU",
                     label_en: "Mauritius",
                     label_it: "Mauritius"
                   },
                   {
                     value: "YT",
                     label_en: "Mayotte",
                     label_it: "Mayotte"
                   },
                   {
                     value: "MX",
                     label_en: "Mexico",
                     label_it: "Messico"
                   },
                   {
                     value: "FM",
                     label_en: "Micronesia",
                     label_it: "Micronesia"
                   },
                   {
                     value: "MD",
                     label_en: "Moldova",
                     label_it: "Moldavia"
                   },
                   {
                     value: "MC",
                     label_en: "Monaco",
                     label_it: "Monaco"
                   },
                   {
                     value: "MN",
                     label_en: "Mongolia",
                     label_it: "Mongolia"
                   },
                   {
                     value: "ME",
                     label_en: "Montenegro",
                     label_it: "Montenegro"
                   },
                   {
                     value: "MS",
                     label_en: "Montserrat",
                     label_it: "Montserrat"
                   },
                   {
                     value: "MA",
                     label_en: "Morocco",
                     label_it: "Marocco"
                   },
                   {
                     value: "MZ",
                     label_en: "Mozambique",
                     label_it: "Mozambico"
                   },
                   {
                     value: "MM",
                     label_en: "Myanmar",
                     label_it: "Myanmar"
                   },
                   {
                     value: "NA",
                     label_en: "Namibia",
                     label_it: "Namibia"
                   },
                   {
                     value: "NR",
                     label_en: "Nauru",
                     label_it: "Nauru"
                   },
                   {
                     value: "NP",
                     label_en: "Nepal",
                     label_it: "Nepal"
                   },
                   {
                     value: "NL",
                     label_en: "Netherlands",
                     label_it: "Olanda"
                   },
                   {
                     value: "NC",
                     label_en: "New Caledonia",
                     label_it: "Nuova Caledonia"
                   },
                   {
                     value: "NZ",
                     label_en: "New Zealand",
                     label_it: "Nuova Zelanda"
                   },
                   {
                     value: "NI",
                     label_en: "Nicaragua",
                     label_it: "Nicaragua"
                   },
                   {
                     value: "NE",
                     label_en: "Niger",
                     label_it: "Niger"
                   },
                   {
                     value: "NG",
                     label_en: "Nigeria",
                     label_it: "Nigeria"
                   },
                   {
                     value: "NU",
                     label_en: "Niue",
                     label_it: "Niue"
                   },
                   {
                     value: "NF",
                     label_en: "Norfolk Island",
                     label_it: "Isola Norfolk"
                   },
                   {
                     value: "MP",
                     label_en: "Northern Mariana Islands",
                     label_it: "Isole Marianne settentrionali"
                   },
                   {
                     value: "NO",
                     label_en: "Norway",
                     label_it: "Norvegia"
                   },
                   {
                     value: "OM",
                     label_en: "Oman",
                     label_it: "Oman"
                   },
                   {
                     value: "PK",
                     label_en: "Pakistan",
                     label_it: "Pakistan"
                   },
                   {
                     value: "PW",
                     label_en: "Palau",
                     label_it: "Palau"
                   },
                   {
                     value: "PS",
                     label_en: "Palestinian Territory, Occupied",
                     label_it: "Territorio palestinese, occupato"
                   },
                   {
                     value: "PA",
                     label_en: "Panama",
                     label_it: "Panama"
                   },
                   {
                     value: "PG",
                     label_en: "Papua New Guinea",
                     label_it: "Papua Nuova Guinea"
                   },
                   {
                     value: "PY",
                     label_en: "Paraguay",
                     label_it: "Paraguay"
                   },
                   {
                     value: "PE",
                     label_en: "Peru",
                     label_it: "Peru"
                   },
                   {
                     value: "PH",
                     label_en: "Philippines",
                     label_it: "Filippine"
                   },
                   {
                     value: "PN",
                     label_en: "Pitcairn",
                     label_it: "Pitcairn"
                   },
                   {
                     value: "PL",
                     label_en: "Poland",
                     label_it: "Polonia"
                   },
                   {
                     value: "PT",
                     label_en: "Portugal",
                     label_it: "Portogallo"
                   },
                   {
                     value: "PR",
                     label_en: "Puerto Rico",
                     label_it: "Porto Rico"
                   },
                   {
                     value: "QA",
                     label_en: "Qatar",
                     label_it: "Qatar"
                   },
                   {
                     value: "RE",
                     label_en: "Réunion",
                     label_it: "Réunion"
                   },
                   {
                     value: "RO",
                     label_en: "Romania",
                     label_it: "Romania"
                   },
                   {
                     value: "RU",
                     label_en: "Russian Federation",
                     label_it: "Russia"
                   },
                   {
                     value: "RW",
                     label_en: "Rwanda",
                     label_it: "Ruanda"
                   },
                   {
                     value: "BL",
                     label_en: "Saint Barthélemy",
                     label_it: "Saint Barthélemy"
                   },
                   {
                     value: "SH",
                     label_en: "Saint Helena, Ascension and Tristan da Cunha",
                     label_it: "Sant'Elena, Ascensione e Tristan da Cunha"
                   },
                   {
                     value: "KN",
                     label_en: "Saint Kitts and Nevis",
                     label_it: "Saint Kitts e Nevis"
                   },
                   {
                     value: "LC",
                     label_en: "Saint Lucia",
                     label_it: "Santa Lucia"
                   },
                   {
                     value: "MF",
                     label_en: "Saint Martin (French part)",
                     label_it: "Saint Martin (parte francese)"
                   },
                   {
                     value: "PM",
                     label_en: "Saint Pierre and Miquelon",
                     label_it: "Saint Pierre e Miquelon"
                   },
                   {
                     value: "VC",
                     label_en: "Saint Vincent and the Grenadines",
                     label_it: "Saint Vincent e Grenadine"
                   },
                   {
                     value: "WS",
                     label_en: "Samoa",
                     label_it: "Samoa"
                   },
                   {
                     value: "SM",
                     label_en: "San Marino",
                     label_it: "San Marino"
                   },
                   {
                     value: "ST",
                     label_en: "Sao Tome and Principe",
                     label_it: "Sao Tome e Principe"
                   },
                   {
                     value: "SA",
                     label_en: "Saudi Arabia",
                     label_it: "Arabia Saudita"
                   },
                   {
                     value: "SN",
                     label_en: "Senegal",
                     label_it: "Senegal"
                   },
                   {
                     value: "RS",
                     label_en: "Serbia",
                     label_it: "Serbia"
                   },
                   {
                     value: "SC",
                     label_en: "Seychelles",
                     label_it: "Seychelles"
                   },
                   {
                     value: "SL",
                     label_en: "Sierra Leone",
                     label_it: "Sierra Leone"
                   },
                   {
                     value: "SG",
                     label_en: "Singapore",
                     label_it: "Singapore"
                   },
                   {
                     value: "SX",
                     label_en: "Sint Maarten (Dutch part)",
                     label_it: "Sint Maarten (parte olandese)"
                   },
                   {
                     value: "SK",
                     label_en: "Slovakia",
                     label_it: "Slovacchia"
                   },
                   {
                     value: "SI",
                     label_en: "Slovenia",
                     label_it: "Slovenia"
                   },
                   {
                     value: "SB",
                     label_en: "Solomon Islands",
                     label_it: "Isole Salomone"
                   },
                   {
                     value: "SO",
                     label_en: "Somalia",
                     label_it: "Somalia"
                   },
                   {
                     value: "ZA",
                     label_en: "South Africa",
                     label_it: "Sud Africa"
                   },
                   {
                     value: "GS",
                     label_en: "South Georgia and the South Sandwich Islands",
                     label_it: "Georgia del Sud e Isole Sandwich del Sud"
                   },
                   {
                     value: "SS",
                     label_en: "South Sudan",
                     label_it: "Sudan del Sud"
                   },
                   {
                     value: "ES",
                     label_en: "Spain",
                     label_it: "Spagna"
                   },
                   {
                     value: "LK",
                     label_en: "Sri Lanka",
                     label_it: "Sri Lanka"
                   },
                   {
                     value: "SD",
                     label_en: "Sudan",
                     label_it: "Sudan"
                   },
                   {
                     value: "SR",
                     label_en: "Suriname",
                     label_it: "Suriname"
                   },
                   {
                     value: "SJ",
                     label_en: "Svalbard and Jan Mayen",
                     label_it: "Svalbard e Jan Mayen"
                   },
                   {
                     value: "SZ",
                     label_en: "Swaziland",
                     label_it: "Swaziland"
                   },
                   {
                     value: "SE",
                     label_en: "Sweden",
                     label_it: "Svezia"
                   },
                   {
                     value: "CH",
                     label_en: "Switzerland",
                     label_it: "Svizzera"
                   },
                   {
                     value: "SY",
                     label_en: "Syrian Arab Republic",
                     label_it: "Repubblica Araba Siriana"
                   },
                   {
                     value: "TW",
                     label_en: "Taiwan",
                     label_it: "Taiwan"
                   },
                   {
                     value: "TJ",
                     label_en: "Tajikistan",
                     label_it: "Tajikistan"
                   },
                   {
                     value: "TZ",
                     label_en: "Tanzania",
                     label_it: "Tanzania"
                   },
                   {
                     value: "TH",
                     label_en: "Thailand",
                     label_it: "Tailandia"
                   },
                   {
                     value: "TL",
                     label_en: "Timor-Leste",
                     label_it: "Timor Est"
                   },
                   {
                     value: "TG",
                     label_en: "Togo",
                     label_it: "Togo"
                   },
                   {
                     value: "TK",
                     label_en: "Tokelau",
                     label_it: "Tokelau"
                   },
                   {
                     value: "TO",
                     label_en: "Tonga",
                     label_it: "Tonga"
                   },
                   {
                     value: "TT",
                     label_en: "Trinidad and Tobago",
                     label_it: "Trinidad e Tobago"
                   },
                   {
                     value: "TN",
                     label_en: "Tunisia",
                     label_it: "Tunisia"
                   },
                   {
                     value: "TR",
                     label_en: "Turkey",
                     label_it: "Turchia"
                   },
                   {
                     value: "TM",
                     label_en: "Turkmenistan",
                     label_it: "Turkmenistan"
                   },
                   {
                     value: "TC",
                     label_en: "Turks and Caicos Islands",
                     label_it: "Isole Turks e Caicos"
                   },
                   {
                     value: "TV",
                     label_en: "Tuvalu",
                     label_it: "Tuvalu"
                   },
                   {
                     value: "UG",
                     label_en: "Uganda",
                     label_it: "Uganda"
                   },
                   {
                     value: "UA",
                     label_en: "Ukraine",
                     label_it: "Ucraina"
                   },
                   {
                     value: "AE",
                     label_en: "United Arab Emirates",
                     label_it: "Emirati Arabi Uniti"
                   },
                   {
                     value: "GB",
                     label_en: "United Kingdom",
                     label_it: "Regno Unito"
                   },
                   {
                     value: "US",
                     label_en: "United States",
                     label_it: "Stati Uniti"
                   },
                   {
                     value: "UM",
                     label_en: "United States Minor Outlying Islands",
                     label_it: "Isole minori secondarie degli Stati Uniti"
                   },
                   {
                     value: "UY",
                     label_en: "Uruguay",
                     label_it: "Uruguay"
                   },
                   {
                     value: "UZ",
                     label_en: "Uzbekistan",
                     label_it: "Uzbekistan"
                   },
                   {
                     value: "VU",
                     label_en: "Vanuatu",
                     label_it: "Vanuatu"
                   },
                   {
                     value: "VE",
                     label_en: "Venezuela",
                     label_it: "Venezuela"
                   },
                   {
                     value: "VN",
                     label_en: "Vietnam",
                     label_it: "Vietnam"
                   },
                   {
                     value: "VG",
                     label_en: "Virgin Islands, British",
                     label_it: "Isole Vergini britanniche"
                   },
                   {
                     value: "VI",
                     label_en: "Virgin Islands, U.S.",
                     label_it: "Isole Vergini americane"
                   },
                   {
                     value: "WF",
                     label_en: "Wallis and Futuna",
                     label_it: "Wallis e Futuna"
                   },
                   {
                     value: "EH",
                     label_en: "Western Sahara",
                     label_it: "Sahara occidentale"
                   },
                   {
                     value: "YE",
                     label_en: "Yemen",
                     label_it: "Yemen"
                   },
                   {
                     value: "ZM",
                     label_en: "Zambia",
                     label_it: "Zambia"
                   },
                   {
                     value: "ZW",
                     label_en: "Zimbabwe",
                     label_it: "Zimbabwe"
                   }
                  ];

  $(document).ready(init);

  function init() {

    // FORM MANAGEMENT
    var countriesList = [];

    var $stores = $(".store-locator-page__body-ul .store-locator-page__li-flagship-store, .store-locator-page__body-ul .store-locator-page__li-retail");
	var $flagships = $(".store-locator-page__body-ul .store-locator-page__li-flagship-store");
    var $retails = $(".store-locator-page__body-ul .store-locator-page__li-retail");
    var $select = $(".store-locator-page__body-form .store-locator-page__body-form-select");
    
    $select.find("option:first-of-type").text( $select.find("option:first-of-type").text() + " (" + $stores.length +")");
    
    $stores.each(function(i, el) {
      var $target = $(el);
      var boo = true;

      if(countriesList.length) {
        for(var j = 0, len = countriesList.length; j < len; j++) {
          if(countriesList[j].code == $target.attr("country")) {
            boo = false;
            break;
          }
        }
      }

      if(!countriesList.length || boo) countriesList.push({code: $target.attr("country"), label: $target.attr("country-label")});
    });

    var optionsMarkup = '';
    for(var i = 0, len = countriesList.length; i < len; i++) {
      var countryLabel = getCountryNamebyValue(countriesList[i].code) + " (" + $('.store-locator-page__body-ul li[country="'+ countriesList[i].code.toUpperCase() +'"]').length + ")";
      optionsMarkup += '<option value="' + countriesList[i].code + '">' + (countryLabel ? countryLabel : countriesList[i].label) + '</option>';
    }

    $select.append(optionsMarkup);

    $(".store-locator-page__body-form input, .store-locator-page__body-form select").on("change", function(e) {
      $(".store-locator-page__body-form").submit();
    });

    $(".store-locator-page__body-form").on("submit", function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var countryCode = $(".store-locator-page__body-form select").val();

      if(countryCode === "ww") {
        $flagships.addClass("visible-in-list");
        $("#store-locator-page__body-retail-ul").html($retails);
      } else {
        $flagships.removeClass("visible-in-list");
        $flagships.each(function(i, el) {
          var $el = $(el);
          if($(el).attr("country") == countryCode) {
            $el.addClass("visible-in-list");
          }
        });

        var retailsList = "";
        
        $retails.each(function(i, el){
          if($(el).attr("country") == countryCode) retailsList += $(el).get(0).outerHTML;
        })
        console.log(retailsList);
        $("#store-locator-page__body-retail-ul").html(jQuery.parseHTML(retailsList));

      }
    });

    // end FORM MANAGEMENT
  }

  function getCountryNamebyValue(value) {
    var countryName;

    for(var i=0, len = countries.length; i < len; i++) {
      if(value == countries[i].value) {
        console.log(value, countries[i].value);
        
        countryName = $("html").attr("data-market") == "it" ? countries[i].label_it : countries[i].label_en;
        break;
      }
    }

    return countryName;
  }
}(window));

